import { fork, takeEvery } from "redux-saga/effects";

import SuggestionConstants from "modules/suggestion/constants";
import SuggestionSagas from "modules/suggestion/sagas";

function* watchGetOpportunityList() {
  yield takeEvery(SuggestionConstants.OPPORTUNITY_LIST, SuggestionSagas.GetOpportunityList);
}

function* watchGetLowPerformanceKeywords() {
  yield takeEvery(SuggestionConstants.LOW_PERFORMANCE_KEYWORDS, SuggestionSagas.GetLowPerformanceKeywords);
}

export default [fork(watchGetOpportunityList), fork(watchGetLowPerformanceKeywords)];
